import { Box } from "@mui/material"
import React, { useContext } from "react"
import CommonTypo from "../../components/CommonTypo"
import NewButton from "../../components/NewButton"
import { UserTypeContext } from "../../context/userStatus"

const UploadFileCost = ({
    onClose,
    isDragging,
    onDragEnter,
    onDragOver,
    onDragLeave,
    onDrop,
    handleUploadFile
}) => {

    return <Box sx={{
        width: "360px",
        padding: "32px",
        gap: "32px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column"
    }}>
        <CommonTypo size={24} lineHeight={24} fontWeight={700} color="var(--color-text-primary)">Import from a .xlsx file</CommonTypo>
        <Box sx={{
            width: "296px",
            padding: "24px",
            gap: "16px",
            display: "flex",
            flexDirection: "column",
            borderRadius: "12px",
            alignItems: "center",
            justifyContent: "center",
            border: "2px dashed var(--color-border)",
            position: "relative",
            backgroundColor: isDragging ? 'rgb(17 115 74 / 20%)' : 'transparent',
        }} onDragEnter={onDragEnter}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}>
            <Box sx={{
                width: "296px",
                padding: "24px",
                gap: "16px",
                display: "flex",
                flexDirection: "column",
                borderRadius: "12px",
                alignItems: "center",
                justifyContent: "center",
            }}>
                {/* <svg width="74" height="88" viewBox="0 0 74 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M65 1H9C4.58172 1 1 4.58172 1 9V62.7929C1 62.9255 1.05268 63.0527 1.14645 63.1464L24.8536 86.8536C24.9473 86.9473 25.0745 87 25.2071 87H65C69.4183 87 73 83.4183 73 79V9C73 4.58172 69.4183 1 65 1Z" stroke="#656565" stroke-width="2" />
                    <path d="M17 63H1L25 87V71C25 66.5817 21.4183 63 17 63Z" stroke="#656565" stroke-width="2" stroke-linejoin="round" />
                    <path d="M18.7601 34.26L19.5521 35.69L16.4941 36.966L19.5741 38.22L18.7381 39.694L16.0761 37.758L16.4281 41.08H14.7781L15.1081 37.758L12.4461 39.716L11.5881 38.22L14.6461 36.944L11.5881 35.712L12.4021 34.238L15.1301 36.196L14.7781 32.852H16.4501L16.0761 36.196L18.7601 34.26ZM23.2773 49.132C22.896 49.132 22.5733 49 22.3093 48.736C22.0453 48.472 21.9133 48.1493 21.9133 47.768C21.9133 47.3867 22.0453 47.064 22.3093 46.8C22.5733 46.536 22.896 46.404 23.2773 46.404C23.644 46.404 23.952 46.536 24.2013 46.8C24.4653 47.064 24.5973 47.3867 24.5973 47.768C24.5973 48.1493 24.4653 48.472 24.2013 48.736C23.952 49 23.644 49.132 23.2773 49.132ZM26.5105 42.95C26.5105 41.7033 26.7598 40.618 27.2585 39.694C27.7571 38.7553 28.4465 38.0293 29.3265 37.516C30.2211 37.0027 31.2405 36.746 32.3845 36.746C33.8658 36.746 35.0831 37.1053 36.0365 37.824C37.0045 38.5427 37.6425 39.54 37.9505 40.816H35.7945C35.5891 40.0827 35.1858 39.5033 34.5845 39.078C33.9978 38.6527 33.2645 38.44 32.3845 38.44C31.2405 38.44 30.3165 38.836 29.6125 39.628C28.9085 40.4053 28.5565 41.5127 28.5565 42.95C28.5565 44.402 28.9085 45.524 29.6125 46.316C30.3165 47.108 31.2405 47.504 32.3845 47.504C33.2645 47.504 33.9978 47.2987 34.5845 46.888C35.1711 46.4773 35.5745 45.8907 35.7945 45.128H37.9505C37.6278 46.36 36.9825 47.35 36.0145 48.098C35.0465 48.8313 33.8365 49.198 32.3845 49.198C31.2405 49.198 30.2211 48.9413 29.3265 48.428C28.4465 47.9147 27.7571 47.1887 27.2585 46.25C26.7598 45.3113 26.5105 44.2113 26.5105 42.95ZM44.8897 49.198C43.9657 49.198 43.1371 49.044 42.4037 48.736C41.6704 48.4133 41.0911 47.9733 40.6657 47.416C40.2404 46.844 40.0057 46.1913 39.9617 45.458H42.0297C42.0884 46.0593 42.3671 46.5507 42.8657 46.932C43.3791 47.3133 44.0464 47.504 44.8677 47.504C45.6304 47.504 46.2317 47.3353 46.6717 46.998C47.1117 46.6607 47.3317 46.2353 47.3317 45.722C47.3317 45.194 47.0971 44.8053 46.6277 44.556C46.1584 44.292 45.4324 44.0353 44.4497 43.786C43.5551 43.5513 42.8217 43.3167 42.2497 43.082C41.6924 42.8327 41.2084 42.4733 40.7977 42.004C40.4017 41.52 40.2037 40.8893 40.2037 40.112C40.2037 39.496 40.3871 38.9313 40.7537 38.418C41.1204 37.9047 41.6411 37.5013 42.3157 37.208C42.9904 36.9 43.7604 36.746 44.6257 36.746C45.9604 36.746 47.0384 37.0833 47.8597 37.758C48.6811 38.4327 49.1211 39.3567 49.1797 40.53H47.1777C47.1337 39.8993 46.8771 39.3933 46.4077 39.012C45.9531 38.6307 45.3371 38.44 44.5597 38.44C43.8411 38.44 43.2691 38.594 42.8437 38.902C42.4184 39.21 42.2057 39.6133 42.2057 40.112C42.2057 40.508 42.3304 40.838 42.5797 41.102C42.8437 41.3513 43.1664 41.5567 43.5477 41.718C43.9437 41.8647 44.4864 42.0333 45.1757 42.224C46.0411 42.4587 46.7451 42.6933 47.2877 42.928C47.8304 43.148 48.2924 43.4853 48.6737 43.94C49.0697 44.3947 49.2751 44.9887 49.2897 45.722C49.2897 46.382 49.1064 46.976 48.7397 47.504C48.3731 48.032 47.8524 48.45 47.1777 48.758C46.5177 49.0513 45.7551 49.198 44.8897 49.198ZM56.6039 47.152L60.3439 36.944H62.4779L57.7479 49H55.4159L50.6859 36.944H52.8419L56.6039 47.152Z" fill="#656565" />
                </svg> */}
                <svg width="74" height="89" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.2959 7.955L15.0459 2.705C14.9415 2.60039 14.8174 2.5174 14.6808 2.46078C14.5442 2.40416 14.3978 2.37501 14.25 2.375H5.25C4.75272 2.375 4.27581 2.57254 3.92417 2.92417C3.57254 3.27581 3.375 3.75272 3.375 4.25V20.75C3.375 21.2473 3.57254 21.7242 3.92417 22.0758C4.27581 22.4275 4.75272 22.625 5.25 22.625H18.75C19.2473 22.625 19.7242 22.4275 20.0758 22.0758C20.4275 21.7242 20.625 21.2473 20.625 20.75V8.75C20.625 8.45187 20.5066 8.16593 20.2959 7.955ZM15 5.84375L17.1562 8H15V5.84375ZM5.625 20.375V4.625H12.75V9.125C12.75 9.42337 12.8685 9.70952 13.0795 9.9205C13.2905 10.1315 13.5766 10.25 13.875 10.25H18.375V20.375H5.625Z" fill="#3E4240" />
                </svg>
            </Box>
            <CommonTypo size={16} lineHeight={20} fontWeight={400} color="var(--color-text-secondary)">Upload the table</CommonTypo>
            <input
                type="file"
                accept=".xlsx"
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    opacity: 0,
                    cursor: 'pointer',
                }}
                onChange={(event) => {
                    const file = event.target.files[0];
                    if (file) {
                        handleUploadFile(file)
                    }
                }}
            />
        </Box>
        <Box sx={{
            gap: "16px",
            display: "flex",
            borderRadius: "12px",
            alignItems: "center",
            justifyContent: "flex-end",
        }}>
            <Box sx={{
                gap: "16px",
                display: "flex",
                borderRadius: "12px",
                alignItems: "center",
            }}>
                <NewButton
                    buttonText="<"
                    // onClick={() => updateRescueTime(selectedTab, checkedKeys, closemodal)}
                    onClick={() => { }}
                    extraSx={{
                        background: "var(--color-border)",
                        border: "none",
                        height: "40px",
                        flex: 1,
                        width: "52px",
                        minWidth: "52px",
                        padding: 0,
                        marginBottom: "0px !important",
                        "&:hover": {
                            background: "var(--color-border)"
                        },
                        "&.MuiButton-outlined": {
                            border: `none`,
                        },
                        "&.MuiButton-contained": {
                            border: `none`,
                        },
                    }} fontSize={`16px`} fontWeight={600} typographySx={{
                        fontSize: "16px !important",
                        lineHeight: "16px !important",
                        fontWeight: `600 !important`,
                        letterSpacing: "2% important",
                        whiteSpace: "nowrap"
                    }}
                />
                <NewButton
                    buttonText=">"
                    // onClick={() => updateRescueTime(selectedTab, checkedKeys, closemodal)}
                    onClick={() => { }}
                    extraSx={{
                        background: "var(--color-new-main)",
                        border: "none",
                        height: "40px",
                        flex: 1,
                        width: "52px",
                        minWidth: "52px",
                        padding: 0,
                        marginBottom: "0px !important",
                        "&:hover": {
                            background: "var(--color-new-main)"
                        },
                        "&.MuiButton-outlined": {
                            border: `none`,
                        },
                        "&.MuiButton-contained": {
                            border: `none`,
                        },
                    }} fontSize={`16px`} boxSx={{
                        padding: 0
                    }} fontWeight={600} typographySx={{
                        fontSize: "16px !important",
                        lineHeight: "16px !important",
                        fontWeight: `600 !important`,
                        letterSpacing: "2% important",
                        whiteSpace: "nowrap"
                    }}
                />
            </Box>
        </Box>
    </Box>
}

export default UploadFileCost